/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Field_Secondary_ColourInputs */

const en_reference_field_secondary_colour = /** @type {(inputs: Reference_Field_Secondary_ColourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secondary colour`)
};

/**
* | output |
* | --- |
* | "Secondary colour" |
*
* @param {Reference_Field_Secondary_ColourInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_field_secondary_colour = /** @type {((inputs?: Reference_Field_Secondary_ColourInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Field_Secondary_ColourInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_field_secondary_colour(inputs)
});